export function isAssistantDemoDismissed(data: unknown, demoId: string): boolean {
  if (!data || typeof data !== 'object') return false
  const raw = (data as { dismissedDemos?: unknown }).dismissedDemos
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return false
  return (raw as Record<string, unknown>)[demoId] === true
}
